const navbar = document.querySelector(".navbar");

window.addEventListener("scroll",() => {
  if (document.documentElement.scrollTop > 0) {
    navbar.classList.add("is-sticky");
  }

  if (document.documentElement.scrollTop <= 0) {
    navbar.classList.remove("is-sticky");
  }
});
